import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.modal.message');
import { Input, ChangeDetectorRef, HostListener } from '@angular/core';

type MessagePart = {
    text: string;
    class?: string;
};

@Component({
    selector: 'wiz-component-modal-message',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.modal.message/view.scss */
:host {
  display: contents;
}`],
})
export class ComponentModalMessageComponent {

    @Input() title = '정보 확인';
    @Input() message = '';
    @Input() messageLines: MessagePart[][] = [];
    @Input() btnAction = '확인';
    @Input() btnClose = '닫기';
    @Input() btnClass = 'bg-[#fbb006] hover:bg-[#fbb006]/70';

    public visible = false;
    public closing = false;

    private resolver: ((value: boolean) => void) | null = null;

    constructor(@Inject( ChangeDetectorRef) private cdr: ChangeDetectorRef) {}

    @HostListener('document:keydown.escape')
    onEscKey() {
        if (this.visible && !this.closing) {
            this.onClose();
        }
    }

    public open(data?: {
        title?: string;
        message?: string;
        messageLines?: MessagePart[][];
        btnAction?: string;
        btnClose?: string;
        btnClass?: string;
    }): Promise<boolean> {

        return new Promise((resolve) => {
            this.resolver = resolve;

            if (data) {
                this.title = data.title ?? '정보 확인';
                this.message = data.message ?? '';
                this.messageLines = data.messageLines ?? [];
                this.btnAction = data.btnAction ?? '확인';
                this.btnClose = data.btnClose ?? '닫기';
                this.btnClass = data.btnClass ?? 'bg-[#fbb006] hover:bg-[#fbb006]/70';
            }

            this.closing = false;
            this.visible = true;
            this.cdr.detectChanges();
        });
    }

    public onBackdropClick() {
        if (!this.closing) {
            this.onClose();
        }
    }

    public onModalClick(event: Event) {
        event.stopPropagation();
    }

    private closeWithAnimation(result: boolean) {
        if (this.closing) return;
        this.closing = true;
        this.cdr.detectChanges();

        setTimeout(() => {
            this.visible = false;
            this.closing = false;
            this.cdr.detectChanges();

            if (this.resolver) {
                this.resolver(result);
                this.resolver = null;
            }
        }, 150);
    }

    public onSubmit() {
        this.closeWithAnimation(true);
    }

    public onClose() {
        this.closeWithAnimation(false);
    }
}

export default ComponentModalMessageComponent;